export const roundHalf = (number) => Math.round((number * 2 )) / 2
